import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'

// firebase init
let firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  // measurementId: process.env.VUE_APP_MEASUREMENT_ID
};
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
if (location.hostname === 'localhost') {
  db.settings({
    host: 'localhost:8080',
    ssl: false
  });
}

const auth = firebase.auth()
if (location.hostname === 'localhost') {
  auth.useEmulator('http://localhost:9099')
}

const funcs = firebase.functions()
if (location.hostname === 'localhost') {
  funcs.useEmulator('localhost', 5001)
}

const storage = firebase.storage()
if (location.hostname === 'localhost') {
  storage.useEmulator('localhost', 9199)
}

// collection references
const usersCollection = db.collection('users')
const packagesCollection = db.collection('packages')
const settingsCollection = db.collection('settings')

// export utils/refs
export {
  auth,
  db,
  funcs,
  packagesCollection,
  settingsCollection,
  storage,
  usersCollection
}
